import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import global from './../../global/global_store/global';

Vue.use(Vuex);

export const createStore = () =>
   new Vuex.Store({
      namespaced: true,
      state: state(),
      actions: actions,
      getters,
      mutations,
      modules: {
         global
      }
});

export default createStore();

// export default {
//    namespaced: true,
//    state: state(),
//    actions,
//    mutations,
//  };